// src/locales/es.js

const es = {
  // --- Common / Global ---
  common_loading: "Cargando...",
  common_error_generic: "Ocurrió un error. Por favor, inténtalo de nuevo.",
  common_previous: "Anterior",
  common_next: "Siguiente",
  common_page: "Página",
  common_of: "de",
  common_site_title: "Astronomyshare.com",
  common_back_to_login: "Volver a Iniciar Sesión",

  // --- Banner ---
  banner_logo_alt: "Astronomy Banner",

  // --- Navigation ---
  nav_home: "Inicio",
  nav_browse: "Explorar",
  nav_upload: "Subir",
  nav_terms: "Términos de Uso",
  nav_privacy: "Política de Privacidad",
  nav_settings: "Configuración de Usuario",
  nav_login: "Accederer",
  nav_register: "Registrarse",
  nav_logout: "Cerrar sesión",

  // --- Footer ---
  footer_extras: "Otras Diversiones",

  // --- Homepage ---
  homepage_short_welcome: 'Bienvenido a AstronomyShare.com',
  homepage_paragraph_one:
    'Esta plataforma está dedicada a revolucionar la forma en que capturamos el cosmos. Nuestro objetivo es proporcionar un espacio donde entusiastas y profesionales por igual puedan compartir sus datos sin procesar, permitiendo que otros integren cientos, o incluso miles, de horas de tiempo de exposición en sus proyectos, en lugar de solo unas pocas decenas. Al combinar recursos y esfuerzos, podemos lograr imágenes impresionantes y de alta calidad del cielo nocturno, superando los límites de lo que es posible en la astrofotografía. ¡Únete a nosotros en este esfuerzo colaborativo para explorar el universo con más detalle que nunca!',
  homepage_paragraph_two:
    'astronomyshare.com está financiado de forma privada y comprometido a mantener la plataforma accesible. Nuestro objetivo es ofrecer este servicio de forma gratuita (prueba) hasta que alcancemos cierto tamaño, momento en el cual se aplicará un costo modesto para ayudar a cubrir los crecientes gastos operativos. Queremos crear una comunidad sostenible y próspera que continúe fomentando la colaboración y la innovación en la astrofotografía durante manyos años.',

  // --- Homepage (Logged in)---
  home_title: "<es translation needed>Welcome Home",
  home_welcome: "<es translation needed>Welcome to AstronomyShare.com",
  home_loading_image_count: "<es translation needed>image count",
  home_image_count_prefix: "<es translation needed>This site is currently hosting ",
  home_image_count_suffix: "<es translation needed>images.",

  // --- Terms of Use ---
  terms_title: 'Términos de Uso',

  // --- Privacy Policy ---
  privacy_policy_title: 'Política de Privacidad',

  // --- Authentication Pages (Login, Register, Forgot, Reset) ---
  auth_login_title: 'Iniciar sesión',
  auth_login_username_label: 'Nombre de usuario',
  auth_login_password_label: 'Contraseña',
  auth_login_submit_button: 'Iniciar sesión',
  auth_login_loading_button: 'Iniciando sesión...',
  auth_login_no_account_prompt: "¿No tienes una cuenta?",
  auth_login_register_link: "Regístrese aquí",
  auth_login_forgot_password_link: "¿Olvidaste tu contraseña?",
  auth_login_verified_message: "¡Correo electrónico verificado! Ya puedes iniciar sesión.",
  auth_login_reset_success_message: "¡Contraseña restablecida con éxito! Ya puedes iniciar sesión.",
  auth_login_username_hint: "Username only, Email not accepted",


  auth_register_title: "Registrarse",
  auth_register_username_label: "Nombre de usuario",
  auth_register_email_label: "Email",
  auth_register_password_label: "Contraseña",
  auth_register_confirm_password_label: "Confirmar contraseña",
  auth_register_loading_button: "Registrando...",
  auth_register_submit_button: "Registrarse",
  auth_register_already_account_prompt: "¿Ya tienes una cuenta?",
  auth_register_login_link: "Inicia sesión aquí",
  auth_register_registration_failed: "Registro fallido. Por favor, inténtalo de nuevo.",
  auth_register_password_hint: "Password must be 8 characters long",

  auth_forgot_password_title: "Restablecer Contraseña",
  auth_forgot_password_instructions: "Introduce la dirección de correo electrónico asociada a tu cuenta. Si existe una cuenta, te enviaremos un enlace para restablecer tu contraseña.",
  auth_forgot_password_email_label: "Dirección de Correo Electrónico",
  auth_forgot_password_submit_button: "Enviar Enlace de Restablecimiento",
  auth_forgot_password_loading_button: "Enviando...",
  auth_forgot_password_back_link: "Volver a Iniciar Sesión",
  auth_forgot_password_button: "Enviar Enlace de Restablecimiento", // Note: Still seems like a duplicate key logic-wise, using same value

  auth_reset_password_title: "Establecer Nueva Contraseña",
  auth_reset_password_new_label: "Nueva Contraseña",
  auth_reset_password_confirm_label: "Confirmar Nueva Contraseña",
  auth_reset_password_submit_button: "Restablecer Contraseña",
  auth_reset_password_loading_button: "Restableciendo...",

  // --- Browse Page ---
  browse_title: "Explora y descarga las imágenes a continuación",
  browse_filter_title: "Limita tu búsqueda:",
  browse_filter_focal_length_label: "Longitud Focal (mm):",
  browse_filter_target_label: "Objetivo:",
  browse_no_images_message: "No hay imágenes que coincidan con tus criterios seleccionados",
  browse_pagination_page: "Página",
  browse_pagination_of: "de",
  browse_images_found_text: "imagen(es) encontrada(s)",
  browse_prev_button: "Anterior",
  browse_next_button: "Siguiente",
  browse_download_button: "Descargar",
  browse_delete_button: "Borrar",
  browse_target_fetch_error: "¡Error al obtener objetivos!",
  browse_images_loading: "cargando imágenes",
  browse_apply_filters_button: "Aplicar Filtros",
  error_auth_token_required: "Auth Token Required",
  browse_error_download_url_missing: "Download URL Missing",
  browse_filter_target_placeholder: "p. ej., M31",
  browse_filter_focal_length_placeholder: "p. ej., 1000",

  // --- Upload Page ---
  upload_title: "Subir Imagen/Datos",
  upload_loading_user: "Cargando información de usuario...",
  upload_loading_targets: "Cargando objetivos...",
  upload_target_error_prefix: "Error al cargar objetivos:",
  upload_no_files_selected_error: "Por favor, selecciona archivos para subir.",
  upload_not_logged_in_error: "Información de usuario no disponible. Por favor, inicia sesión de nuevo.",
  upload_target_required_error: "Por favor, selecciona o introduce un nombre de objetivo.",
  upload_metadata_title: "Metadatos de Imagen (Aplica a todos los archivos seleccionados)",
  upload_target_label: "Objetivo:",
  upload_target_select_placeholder: "Selecciona existente o escribe para crear...",
  upload_focal_length_label: "Distancia Focal (mm):",
  upload_exposure_time_label: "Tiempo de Exposición (s):",
  upload_filter_used_label: "Filtro Usado:",
  upload_select_files_label: "Seleccionar Archivos:",
  upload_submit_button: "Subir Archivos Seleccionados",
  upload_loading_button: "Subiendo...",
  upload_progress_title: "Estado de la Subida",
  upload_overall_progress_label: "Progreso Total del Lote",
  upload_summary_title: "Resumen de Subida",
  upload_status_uploading: "Subiendo archivo {{current}} de {{total}}{{filename_part}} - {{progress}}%",
  upload_status_success: "Archivo {{current}} de {{total}} subido{{filename_part}}",
  upload_status_error: "Error al subir archivo {{current}} de {{total}}{{filename_part}}: {{error}}",
  upload_status_pending: "Preparando archivo {{current}} de {{total}}{{filename_part}}...",
  upload_status_error_default: "Falló",
  upload_error_s3_failed: "S3 upload failed",
  upload_error_invalid_file_type_selected: "Tipo(s) de archivo no válido(s): {{invalidNames}}. Tipos permitidos: FITS, XISF, JPG, PNG, TIFF.",
  API_UPLOAD_CONFIRM_INVALID_SIZE: "Invalid file size received in confirmation.",
  API_UPLOAD_CONFIRM_QUOTA_EXCEEDED: "Upload Failed: Storage quota exceeded",

  // Download
  download_error_missing_key_local: "Download Error: Missing Key",

  // Using English as placeholder - Needs Translation!
  API_AUTH_REGISTRATION_SUCCESS_VERIFY_EMAIL: 'Registration successful! Please check your email for a verification link.',
  API_AUTH_VERIFICATION_SUCCESS: 'Email successfully verified! Please log in.',
  API_AUTH_PASSWORD_RESET_SUCCESS: 'Password has been reset successfully! You can now log in.',
  API_AUTH_LOGIN_SUCCESS: 'Login successful! Redirecting...',
  API_AUTH_LOGIN_NO_TOKEN: "Login failed: Authentication incomplete. Please try again.",
  API_AUTH_MISSING_FIELDS: 'All required fields must be filled.',
  API_AUTH_INVALID_EMAIL_FORMAT: 'Please enter a valid email format.',
  API_AUTH_PASSWORD_TOO_SHORT: 'Password must be at least 8 characters long.',
  API_AUTH_PASSWORD_MISMATCH: 'Passwords do not match.',
  API_AUTH_USERNAME_TAKEN: 'Username is already taken. Please choose another.',
  API_AUTH_EMAIL_TAKEN: 'This email address is already registered.',
  API_AUTH_INVALID_CREDENTIALS: 'Invalid username or password.',
  API_AUTH_ACCOUNT_NOT_VERIFIED: 'Account not verified. Please check your email for the verification link.',
  API_AUTH_TOKEN_MISSING: 'Verification or reset token is missing.',
  API_AUTH_TOKEN_INVALID_OR_EXPIRED: 'This verification or password reset link is invalid or has expired.',
  API_AUTH_PASSWORD_RESET_FAILED: 'Failed to reset password. The link may be invalid or expired, or a server error occurred.',
  API_AUTH_FORGOT_PASSWORD_SENT: 'If an account with that email address exists, a password reset link has been sent.', 
  API_AUTH_FORBIDDEN: "You are not authorized to perform this action",
  API_USER_NOT_FOUND: "Username not found",
  API_DOWNLOAD_MISSING_KEY: "Required object key parameter is missing or invalid.", 
  API_FILE_MISSING_KEY: "Object Key Missing, Delete Failed", 
  API_FILE_DELETE_SUCCESS: "Object Successfully Deleted", 
  API_SERVER_ERROR_GENERIC: 'An unexpected server error occurred. Please try again later.',
  API_INVALID_PARAMETER: "Invalid request parameter value.",
};

export default es;